
















import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import APP_UTILITIES from '@/utilities/commonFunctions';
import UIkit from 'uikit';
import discountStore from '@/store/modules/discounts';
import { Discount } from '@/Model/discounts/types';

/**
 * Vue component for displaying a mobile discount tooltip.
 * @component
 */
@Component
export default class MobileDiscountTooltip extends Vue {
  /**
   * Synchronized prop indicating if the discount is a multi-participant discount.
   * @prop {boolean} isMultiParticipantDiscountSync
   */
  @PropSync('isMultiParticipantDiscount', { type: Boolean, required: true }) isMultiParticipantDiscountSync!: boolean;

  /**
   * Indicates if the discount is a multi-participant discount.
   * @prop {boolean} isMultiParticipantDiscount
   */
  @Prop({ type: Boolean, default: false }) isMultiParticipantDiscount!: boolean;

  /**
   * The unique ID for the tooltip.
   * @type {string}
   */
  tooltipId: string = '';

  /**
   * Gets the discount description text from the discount store.
   * @returns {string} The discount description text.
   */
  get discountDescriptionText(): string {
    return discountStore.discountDescriptionText;
  }

  /**
   * Gets the multi-participant discount data from the discount store.
   * @returns {Discount|null} The multi-participant discount data or null if it doesn't exist.
   */
  get multiParticipantDiscountData(): Discount | null {
    return discountStore.multiParticipantDiscountData || null;
  }

  /**
   * Gets the multi-participant discount name.
   * @returns {string} The multi-participant discount name.
   */
  get multiDiscountName(): string {
    return this.multiParticipantDiscountData
      ? this.multiParticipantDiscountData.name
      : '';
  }

  /**
   * Gets the tooltip description for the discount.
   * @returns {string} The tooltip description.
   */
  get tooltipDescription(): string {
    return this.multiParticipantDiscountData
      ? this.multiParticipantDiscountData.description
      : '';
  }

  /**
   * Lifecycle hook called when the component is created.
   * Generates a unique tooltip ID.
   */
  created() {
    this.tooltipId = APP_UTILITIES.generateRandomAlphanumericId(10);
  }

  /**
   * Lifecycle hook called before the component is destroyed.
   * Hides the UIkit modal.
   */
  beforeDestroy() {
    UIkit.modal(`#${this.tooltipId}`).hide();
  }
}
